import Bugsnag from '@bugsnag/js';

// Single notify helper used at every UI catch site. Combines the API
// context Api.js attached to the error (method/url/status/requestId/
// sanitized response) with the call-site context (component + method)
// into a single Bugsnag event so the dashboard shows both who initiated
// the request and what the API said.
//
// Usage:
//   } catch (err) {
//     notifyError(err, { component: 'DepositReconciliation', method: 'fetchData' });
//     setError(true);
//   }
export const notifyError = (err, callSite) => {
  try {
    Bugsnag.notify(err, (event) => {
      if (callSite) event.addMetadata('callSite', callSite);
      const apiCtx = err && err.__apiContext;
      if (apiCtx) event.addMetadata('api', apiCtx);
    });
  } catch (_) {
    // Never let instrumentation throw from a catch block.
  }
};

export default notifyError;
